'use strict';
/* Form Handling */
(function (window, $) {
    var $removeProductListItem = $('.jwsdw-wishlist-removeItem'),
        $addProductListItem = $('.jwsdw-wishlist-undo'),
        $storeAvailability = $('.jwsdw-wishlist-storeAvailability'),
        itemToRemoveID;

    /**
     * @description Method to handle form submits
     * @param {String} url endpoint
     * @param {Object} data parameter map
     * @param {Function} successCallback the callback that is triggered when the ajax call was successful
     * @param {Function} errorCallback the callback that is triggered when the ajax call was unsuccessful
     * @param {Function} completeCallback the callback that is triggered when the ajax call is completed
     * @returns {void}
     */
    function ajax (url, data, successCallback, errorCallback, completeCallback) {
        data[window.jwsdwSettings.csrfTokenName] = window.jwsdwSettings.csrfTokenValue;

        // XHR request to form action url with form fields as parameters
        $.ajax(url, {
            'method': 'POST',
            'data': data,
            'error': errorCallback,
            'success': successCallback,
            'complete': completeCallback
        });
    }

    /**
     * @description Method to execute if wishlist item was removed successfully.
     * @param {object} data the response data
     * @returns {undefined}
     */
    function removeProductListItemSuccessCallback (data) {
        window.jwsdwMediator.publish('setWishlistCount', data.items);
    }

    /**
     * @description Method to execute if wishlist item was added successfully.
     * @param {object} data the response data
     * @returns {undefined}
     */
    function addProductListItemSuccessCallback (data) {
        var $container = $('.jwsdw-wishlist-item-container[data-product-id=' + data.productId + ']');
        $container.find('.jwsdw-wishlist-removeItem').data('item-id', data.itemId);
        window.jwsdwMediator.publish('setWishlistCount', data.items);
    }

    /* Closing picker after adding to cart */
    window.jwsdwMediator.subscribe('afterPickerOpen', (type) => {
        if (type === 'cartPicker') {
            window.jwsdwMediator.publish('closePicker', 'wishlistToBasketPicker', true);
        }
    });

    /* Handling add to cart button to open size picker */
    $('.jwsdw-addToCartButton').on('click', function () {
        let $productContainer = $(this).closest('.jwsdw-wishlist-item-container');
        let sizeSwatches = JSON.parse($productContainer.attr('data-size-swatches'));
        let itemID = $productContainer.data('itemId');
        let variantID = $productContainer.data('colorVariantId');
        let productName = $productContainer.data('productName');
        let minPrice = $productContainer.data('minPrice');
        let pdpUrl = $productContainer.data('pdpUrl');
        let color = $productContainer.data('color');
        let colorName = $productContainer.data('colorName');
        let initialListPrice = $productContainer.data('initialListPrice');
        let isSaleProduct = $productContainer.data('isSaleProduct');

        window.jwsdwMediator.publish('openPicker', 'wishlistToBasketPicker', {
            'product': {
                'itemID': itemID,
                'id': variantID,
                'name': productName,
                'minPrice': minPrice,
                'url': pdpUrl,
                'color': color,
                'colorName': colorName,
                'initialListPrice': initialListPrice,
                'isSaleProduct': isSaleProduct
            },
            'sizeSwatches': sizeSwatches
        });
    });

    /* Handling swatch change event */
    $('body').on('click', '.jwsdw-product-swatch-selectable:not(.jwsdw-product-swatch-active)', function () {
        let $swatch = $(this);
        let price = $swatch.data('price');
        let priceValue = $swatch.data('priceValue');
        let pid = $swatch.data('pid');

        window.jwsdwMediator.subscribe('exposePickerContext.wishlistToBasketPicker', (data) => {
            window.jwsdwMediator.remove('exposePickerContext.wishlistToBasketPicker');

            let sizeSwatches = data.sizeSwatches;
            let product = data.product;
            let selectedSwatch;
            sizeSwatches.forEach((swatch) => {
                swatch.selected = swatch.productID === pid;

                if (swatch.selected) {
                    selectedSwatch = swatch;
                }
            });

            itemToRemoveID = $swatch.data('itemId');

            Object.assign(product, {
                'price': price,
                'priceValue': priceValue,
                'variantID': pid,
                'size': selectedSwatch.value,
                'listPrice': selectedSwatch.listPrice,
                'salePrice': selectedSwatch.salePrice,
                'isSaleProduct': selectedSwatch.isSaleProduct
            });

            /* Updating picker scope */
            window.jwsdwMediator.publish('updatePicker', 'wishlistToBasketPicker', {
                'product': product,
                'sizeSwatches': sizeSwatches
            });
        });

        window.jwsdwMediator.publish('getPickerContext', 'wishlistToBasketPicker');
    });

    $removeProductListItem.on('click', function () {
        var $button = $(this),
            $container = $button.parents('.jwsdw-wishlist-item-container');
        $container.find('.jwsdw-wishlist-item').addClass('jws-hidden');
        $container.find('.jwsdw-wishlist-deletedItem').removeClass('jws-hidden');

        ajax(
            $button.data('url'),
            {
                'productListId': $button.data('productlist-id'),
                'itemId': $button.data('item-id')
            },
            removeProductListItemSuccessCallback
        );
    });

    window.jwsdwMediator.subscribe('cartPickerUpdated', function() {
        if ($('.jwsdw-wishlist-removeItem[data-item-id="' + itemToRemoveID + '"]').is(':visible')) {
            $('.jwsdw-wishlist-removeItem[data-item-id="' + itemToRemoveID + '"]').click();
        }
    });

    $addProductListItem.on('click', function () {
        var $button = $(this),
            $container = $button.parents('.jwsdw-wishlist-item-container');
        $container.find('.jwsdw-wishlist-item').removeClass('jws-hidden');
        $container.find('.jwsdw-wishlist-deletedItem').addClass('jws-hidden');

        ajax(
            $button.data('url'),
            {
                'productId': $button.data('product-id')
            },
            addProductListItemSuccessCallback
        );
    });

    $('body').on('click', '.jwsdw-product-swatch.jwsdw-not-in-stock', function () {
        window.jwsdwMediator.subscribe('exposePickerContext.wishlistToBasketPicker', (data) => {
            window.jwsdwMediator.remove('exposePickerContext.wishlistToBasketPicker');

            let $swatch = $(this);
            let product = data.product;

            window.jwsdwMediator.publish('openPicker', 'notifyMePicker', {
                'width': 1,
                'productID': $swatch.data('pid'),
                'productName': product.name,
                'productSize': $swatch.data('value'),
                'productColor': product.colorName,
                'image': $('#jwsdw-wishlistToBasketPicker picture img').attr('data-ng-srcset').split(',')[0],
                'isVisible': true,
                'level': 2
            });
        });

        window.jwsdwMediator.publish('getPickerContext', 'wishlistToBasketPicker');
    });

    $storeAvailability.on('click', function() {
        window.jwsdwMediator.publish('openPicker', 'storeAvailabilityListPicker', {
            'productId': $(this).data('product-id')
        });
    });

    /**events for product list impression on page load*/
    $(window).on('load', function () {
        let oldLayer = window.dynamic_tm_data,
            itemContainer = $('.jwsdw-wishlist-item-container'),
            productImpressions = [],
            clickEvent = {};
        if (itemContainer.length > 0) {
            itemContainer.each(function () {
                productImpressions.push({
                    'name': $(this).attr('data-product-name'),
                    'category': $(this).attr('data-product-category'),
                    'id': $(this).attr('data-color-variant-id'),
                    'price': $(this).attr('data-min-price'),
                    'brand': 'Jack Wolfskin GmbH & Co. KGaA',
                    'variant': $(this).attr('data-color-name'),
                    'list': 'wishlist',
                    'position': 1,
                    'dimension13': $(this).attr('data-color-variant-id').split('_').shift(),
                    'dimension14': 'wishlist product listing'
                });
            });
            if (productImpressions[0].id) {
                clickEvent = {
                    'event': 'eec.productListImpression',
                    'eventCategory': 'ecommerce',
                    'eventAction': 'product list impression',
                    'eventLabel': 'wishlist',
                    'eventValue': undefined,
                    'nonInteraction': true,
                    'ecommerce': {
                        'currencyCode': oldLayer.currency,
                        'impressions': productImpressions
                    }
                };
                try {
                    window.dataLayer.push(clickEvent);
                } catch (error) {
                    $(window).console.error('An error occurred executing tracking callback in Wishlist.js for event: ' + 'eec.ProductListImptrddion' + '. Error: ' + error);
                }
            }
        }
    });

    /* event for Product list impression */
    $('.jws-product-page-link').click(function () {
        let oldLayer = window.dynamic_tm_data,
            itemContainer = $(this).closest('.jwsdw-wishlist-item-container'),
            productImpression = {
                'name': itemContainer.attr('data-product-name'),
                'category': itemContainer.attr('data-product-category'),
                'id': itemContainer.attr('data-color-variant-id'),
                'price': itemContainer.attr('data-min-price'),
                'brand': 'Jack Wolfskin GmbH & Co. KGaA',
                'variant':itemContainer.attr('data-color-name'),
                'list': 'wishlist',
                'position': 1,
                'dimension13': itemContainer.attr('data-color-variant-id').split('_').shift(),
                'dimension14': 'wishlist product listing'
            },
            clickEvent = {
                'event': 'eec.productListClick',
                'eventCategory': 'ecommerce',
                'eventAction': 'product list click',
                'eventLabel': 'wishlist',
                'eventValue': undefined,
                'nonInteraction': true,
                'ecommerce': {
                    'currencyCode': oldLayer.currency,
                    'click': {
                        'actionField': { 'list': 'wishlist' },
                        'impressions': [productImpression]
                    }
                }
            };

        if (productImpression.id) {
            try {
                window.dataLayer.push(clickEvent);
            } catch (error) {
                $(window).console.error('An error occurred executing tracking callback in Wishlist.js for event: ' + 'eec.ProductListImptrddion' + '. Error: ' + error);
            }
        }
    });
}(window, jQuery));


